export default __webpack_public_path__ + "static/erik_bw-cc0c70742d33225306c0a65b29c96f78.jpg";